module.exports = __webpack_public_path__ + "static/img/The Moon.76e2d49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Moon.jpg
// module id = 1320
// module chunks = 0